'use strict';
var PRIMARY = '$WORDMARK_PRIMARY$',
    VECTOR_PRIMARY = '$VECTOR_WORDMARK_PRIMARY$',
    CHECKOUT_LOGO = '$CHECKOUT_PRIMARY$',
    VECTOR_CHECKOUT_LOGO = '$VECTOR_CHECKOUT_PRIMARY$',
    CHECKOUT_REVERSE_LOGO = '$CHECKOUT_REVERSE$',
    CREDIT_LOGO = '$QUATERNARY_PRIMARY$',
    VECTOR_CREDIT_LOGO = '$VECTOR_QUATERNARY_PRIMARY$',
    VECTOR_CHECKOUT_REVERSE_LOGO = '$VECTOR_CHECKOUT_REVERSE$';
module.exports = {
    BN_CODE: 'JavaScriptButtons_{label}',
    PAYPAL_URL: 'https://{host}/cgi-bin/webscr',
    QR_URL: 'https://{host}/webapps/ppint/qrcode?data={url}&pattern={pattern}&height={size}',
    QR_PATTERN: 13,
    QR_SIZE: 250,
    LIMITS: {
        width: {
            min: 100,
            max: 500
        },
        height: {
            min: 24,
            max: 100
        },
        length: {
            max: 60
        },
        length_with_wordmark: {
            max: 40
        }
    },
    PRETTY_PARAMS: {
        name: 'item_name',
        number: 'item_number',
        locale: 'lc',
        currency: 'currency_code',
        recurrence: 'p3',
        period: 't3',
        callback: 'notify_url',
        button_id: 'hosted_button_id'
    },
    WIDGET_NAME: 'paypal-button-widget',
    DEFAULT_HOST: 'www.paypal.com',
    DEFAULT_TYPE: 'button',
    DEFAULT_LABEL: 'buynow',
    DEFAULT_SIZE: 'large',
    DEFAULT_STYLE: 'primary',
    DEFAULT_LOCALE: 'en_US',
    DEFAULT_ENV: 'www',
    STRINGS: '$STRINGS$',
    STYLES: '$STYLES$',
    LOGO: '$LOGO$',
    VECTOR_LOGO: '$VECTOR_LOGO$',
    WORDMARK: {
        primary: PRIMARY,
        secondary: '$WORDMARK_SECONDARY$',
        tertiary: '$PP_LEGACY_LOGO_2X$',
        quaternary: CREDIT_LOGO,
        vector_primary: VECTOR_PRIMARY,
        vector_secondary: '$VECTOR_WORDMARK_SECONDARY$',
        vector_tertiary: '$VECTOR_PP_LEGACY_LOGO_2X$',
        vector_quaternary: VECTOR_CREDIT_LOGO,
        checkout: CHECKOUT_LOGO,
        vector_checkout: VECTOR_CHECKOUT_LOGO,
        checkout_reverse: CHECKOUT_REVERSE_LOGO,
        vector_checkout_reverse: VECTOR_CHECKOUT_REVERSE_LOGO
    },
    CHECKOUT_COLORS: ['gold', 'silver', 'blue'],
    DEFAULT_CHECKOUT_COLOR: 'gold',
    BUTTON_SHAPES: ['pill', 'rect'],
    DEFAULT_SHAPE: 'pill',
    CHECKOUT_NEW_UNSUPPORTED_LOCALES: [],
    SUPPORTED_LOCALES: ['en_AD', 'es_AD', 'fr_AD', 'zh_AD',
        'ar_AE', 'en_AE', 'es_AE', 'fr_AE', 'zh_AE',
        'en_AG', 'es_AG', 'fr_AG', 'zh_AG',
        'en_AI', 'es_AI', 'fr_AI', 'zh_AI',
        'en_AL',
        'en_AM', 'es_AM', 'fr_AM', 'zh_AM',
        'en_AN', 'es_AN', 'fr_AN', 'zh_AN',
        'en_AO', 'es_AO', 'fr_AO', 'zh_AO',
        'en_AR', 'es_AR',
        'en_AT', 'de_AT',
        'en_AU',
        'en_AW', 'es_AW', 'fr_AW', 'zh_AW',
        'en_AZ', 'es_AZ', 'fr_AZ', 'zh_AZ',
        'en_BA',
        'en_BB', 'es_BB', 'fr_BB', 'zh_BB',
        'en_BE', 'fr_BE', 'nl_BE',
        'en_BF', 'es_BF', 'fr_BF', 'zh_BF',
        'en_BG',
        'ar_BH', 'en_BH', 'es_BH', 'fr_BH', 'zh_BH',
        'en_BI', 'es_BI', 'fr_BI', 'zh_BI',
        'en_BJ', 'es_BJ', 'fr_BJ', 'zh_BJ',
        'en_BM', 'es_BM', 'fr_BM', 'zh_BM',
        'en_BN',
        'en_BO', 'es_BO', 'fr_BO', 'zh_BO',
        'pt_BR',
        'en_BS', 'es_BS', 'fr_BS', 'zh_BS',
        'en_BT',
        'en_BW', 'es_BW', 'fr_BW', 'zh_BW',
        'en_BY',
        'en_BZ', 'es_BZ', 'fr_BZ', 'zh_BZ',
        'en_C2', 'zh_C2',
        'fr_CA',
        'en_CD', 'es_CD', 'fr_CD', 'zh_CD',
        'en_CG', 'es_CG', 'fr_CG', 'zh_CG',
        'de_CH', 'en_CH', 'fr_CH',
        'en_CI', 'fr_CI',
        'en_CK', 'es_CK', 'fr_CK', 'zh_CK',
        'en_CL', 'es_CL', 'fr_CL', 'zh_CL',
        'en_CM', 'fr_CM',
        'zh_CN',
        'en_CO', 'es_CO', 'fr_CO', 'zh_CO',
        'en_CR', 'es_CR', 'fr_CR', 'zh_CR',
        'en_CV', 'es_CV', 'fr_CV', 'zh_CV',
        'en_CY',
        'en_CZ', 'es_CZ', 'fr_CZ', 'zh_CZ',
        'de_DE',
        'en_DJ', 'es_DJ', 'fr_DJ', 'zh_DJ',
        'da_DK',
        'en_DM', 'es_DM', 'fr_DM', 'zh_DM',
        'en_DO', 'es_DO', 'fr_DO', 'zh_DO',
        'ar_DZ', 'en_DZ', 'es_DZ', 'fr_DZ', 'zh_DZ',
        'en_EC', 'es_EC', 'fr_EC', 'zh_EC',
        'en_EE', 'es_EE', 'fr_EE', 'ru_EE', 'zh_EE',
        'ar_EG', 'en_EG', 'es_EG', 'fr_EG', 'zh_EG',
        'en_ER', 'es_ER', 'fr_ER', 'zh_ER',
        'es_ES',
        'en_ET', 'es_ET', 'fr_ET', 'zh_ET',
        'en_FI', 'es_FI', 'fr_FI', 'zh_FI',
        'en_FJ', 'es_FJ', 'fr_FJ', 'zh_FJ',
        'en_FK', 'es_FK', 'fr_FK', 'zh_FK',
        'en_FM',
        'da_FO', 'en_FO', 'es_FO', 'fr_FO', 'zh_FO',
        'fr_FR',
        'en_GA', 'es_GA', 'fr_GA', 'zh_GA',
        'en_GB',
        'en_GD', 'es_GD', 'fr_GD', 'zh_GD',
        'en_GE', 'es_GE', 'fr_GE', 'zh_GE',
        'en_GF', 'es_GF', 'fr_GF', 'zh_GF',
        'en_GI', 'es_GI', 'fr_GI', 'zh_GI',
        'da_GL', 'en_GL', 'es_GL', 'fr_GL', 'zh_GL',
        'en_GM', 'es_GM', 'fr_GM', 'zh_GM',
        'en_GN', 'es_GN', 'fr_GN', 'zh_GN',
        'en_GP', 'es_GP', 'fr_GP', 'zh_GP',
        'en_GR', 'es_GR', 'fr_GR', 'zh_GR',
        'en_GT', 'es_GT', 'fr_GT', 'zh_GT',
        'en_GW', 'es_GW', 'fr_GW', 'zh_GW',
        'en_GY', 'es_GY', 'fr_GY', 'zh_GY',
        'zh_HK',
        'en_HN', 'es_HN', 'fr_HN', 'zh_HN',
        'en_HR',
        'en_HU', 'es_HU', 'fr_HU', 'zh_HU',
        'id_ID',
        'en_IE', 'es_IE', 'fr_IE', 'zh_IE',
        'he_IL',
        'en_IN',
        'en_IS',
        'it_IT',
        'en_JM', 'es_JM', 'fr_JM', 'zh_JM',
        'ar_JO', 'en_JO', 'es_JO', 'fr_JO', 'zh_JO',
        'ja_JP',
        'en_KE', 'es_KE', 'fr_KE', 'zh_KE',
        'en_KG', 'es_KG', 'fr_KG', 'zh_KG',
        'en_KH',
        'en_KI', 'es_KI', 'fr_KI', 'zh_KI',
        'en_KM', 'es_KM', 'fr_KM', 'zh_KM',
        'en_KN', 'es_KN', 'fr_KN', 'zh_KN',
        'en_KR', 'ko_KR',
        'ar_KW', 'en_KW', 'es_KW', 'fr_KW', 'zh_KW',
        'en_KY', 'es_KY', 'fr_KY', 'zh_KY',
        'en_KZ', 'es_KZ', 'fr_KZ', 'zh_KZ',
        'en_LA',
        'en_LC', 'es_LC', 'fr_LC', 'zh_LC',
        'en_LI', 'es_LI', 'fr_LI', 'zh_LI',
        'en_LK',
        'en_LS', 'es_LS', 'fr_LS', 'zh_LS',
        'en_LT', 'es_LT', 'fr_LT', 'ru_LT', 'zh_LT',
        'de_LU', 'en_LU', 'es_LU', 'fr_LU', 'zh_LU',
        'en_LV', 'es_LV', 'fr_LV', 'ru_LV', 'zh_LV',
        'ar_MA', 'en_MA', 'es_MA', 'fr_MA', 'zh_MA',
        'en_MC', 'fr_MC',
        'en_MD',
        'en_ME',
        'en_MG', 'es_MG', 'fr_MG', 'zh_MG',
        'en_MH', 'es_MH', 'fr_MH', 'zh_MH',
        'en_MK',
        'en_ML', 'es_ML', 'fr_ML', 'zh_ML',
        'en_MN',
        'en_MQ', 'es_MQ', 'fr_MQ', 'zh_MQ',
        'en_MR', 'es_MR', 'fr_MR', 'zh_MR',
        'en_MS', 'es_MS', 'fr_MS', 'zh_MS',
        'en_MT',
        'en_MU', 'es_MU', 'fr_MU', 'zh_MU',
        'en_MV',
        'en_MW', 'es_MW', 'fr_MW', 'zh_MW',
        'en_MX', 'es_MX',
        'en_MY',
        'en_MZ', 'es_MZ', 'fr_MZ', 'zh_MZ',
        'en_NA', 'es_NA', 'fr_NA', 'zh_NA',
        'en_NC', 'es_NC', 'fr_NC', 'zh_NC',
        'en_NE', 'es_NE', 'fr_NE', 'zh_NE',
        'en_NF', 'es_NF', 'fr_NF', 'zh_NF',
        'en_NG',
        'en_NI', 'es_NI', 'fr_NI', 'zh_NI',
        'nl_NL',
        'no_NO',
        'en_NP',
        'en_NR', 'es_NR', 'fr_NR', 'zh_NR',
        'en_NU', 'es_NU', 'fr_NU', 'zh_NU',
        'en_NZ', 'es_NZ', 'fr_NZ', 'zh_NZ',
        'ar_OM', 'en_OM', 'es_OM', 'fr_OM', 'zh_OM',
        'en_PA', 'es_PA', 'fr_PA', 'zh_PA',
        'en_PE', 'es_PE', 'fr_PE', 'zh_PE',
        'en_PF', 'es_PF', 'fr_PF', 'zh_PF',
        'en_PG', 'es_PG', 'fr_PG', 'zh_PG',
        'en_PH',
        'pl_PL',
        'en_PM', 'es_PM', 'fr_PM', 'zh_PM',
        'en_PN', 'es_PN', 'fr_PN', 'zh_PN',
        'pt_PT',
        'en_PW', 'es_PW', 'fr_PW', 'zh_PW',
        'en_PY', 'es_PY',
        'ar_QA', 'en_QA', 'es_QA', 'fr_QA', 'zh_QA',
        'en_RE', 'es_RE', 'fr_RE', 'zh_RE',
        'en_RO', 'es_RO', 'fr_RO', 'zh_RO',
        'en_RS', 'es_RS', 'fr_RS', 'zh_RS',
        'ru_RU',
        'en_RW', 'es_RW', 'fr_RW', 'zh_RW',
        'ar_SA', 'en_SA', 'es_SA', 'fr_SA', 'zh_SA',
        'en_SB', 'es_SB', 'fr_SB', 'zh_SB',
        'en_SC', 'es_SC', 'fr_SC', 'zh_SC',
        'sv_SE',
        'en_SG',
        'en_SH', 'es_SH', 'fr_SH', 'zh_SH',
        'en_SI', 'es_SI', 'fr_SI', 'zh_SI',
        'en_SJ', 'es_SJ', 'fr_SJ', 'zh_SJ',
        'en_SK', 'es_SK', 'fr_SK', 'zh_SK',
        'en_SL', 'es_SL', 'fr_SL', 'zh_SL',
        'en_SM', 'es_SM', 'fr_SM', 'zh_SM',
        'en_SN', 'es_SN', 'fr_SN', 'zh_SN',
        'en_SO', 'es_SO', 'fr_SO', 'zh_SO',
        'en_SR', 'es_SR', 'fr_SR', 'zh_SR',
        'en_ST', 'es_ST', 'fr_ST', 'zh_ST',
        'en_SV', 'es_SV', 'fr_SV', 'zh_SV',
        'en_SZ', 'es_SZ', 'fr_SZ', 'zh_SZ',
        'en_TC', 'es_TC', 'fr_TC', 'zh_TC',
        'en_TD', 'es_TD', 'fr_TD', 'zh_TD',
        'en_TG', 'es_TG', 'fr_TG', 'zh_TG',
        'th_TH',
        'en_TJ', 'es_TJ', 'fr_TJ', 'zh_TJ',
        'en_TM', 'es_TM', 'fr_TM', 'zh_TM',
        'ar_TN', 'en_TN', 'es_TN', 'fr_TN', 'zh_TN',
        'en_TO',
        'tr_TR',
        'en_TT', 'es_TT', 'fr_TT', 'zh_TT',
        'en_TV', 'es_TV', 'fr_TV', 'zh_TV',
        'zh_TW',
        'en_TZ', 'es_TZ', 'fr_TZ', 'zh_TZ',
        'en_UA', 'es_UA', 'fr_UA', 'ru_UA', 'zh_UA',
        'en_UG', 'es_UG', 'fr_UG', 'zh_UG',
        'en_US', 'es_US', 'fr_US', 'zh_US',
        'en_UY', 'es_UY', 'fr_UY', 'zh_UY',
        'en_VA', 'es_VA', 'fr_VA', 'zh_VA',
        'en_VC', 'es_VC', 'fr_VC', 'zh_VC',
        'en_VE', 'es_VE', 'fr_VE', 'zh_VE',
        'en_VG', 'es_VG', 'fr_VG', 'zh_VG',
        'en_VN',
        'en_VU', 'es_VU', 'fr_VU', 'zh_VU',
        'en_WF', 'es_WF', 'fr_WF', 'zh_WF',
        'en_WS',
        'ar_YE', 'en_YE', 'es_YE', 'fr_YE', 'zh_YE',
        'en_YT', 'es_YT', 'fr_YT', 'zh_YT',
        'en_ZA', 'es_ZA', 'fr_ZA', 'zh_ZA',
        'en_ZM', 'es_ZM', 'fr_ZM', 'zh_ZM',
        'en_ZW'],
    CHECKOUT_SIZES: ['tiny', 'small', 'medium']
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/constants.js
 ** module id = 3
 ** module chunks = 0
 **/